const downloadList = []
const downloadMap = {}
export default class file {
  player
  constructor(player, loadFileParams) {
    this.player = player
    this.setConnect()
    if (loadFileParams?.fileList) {
      if (!Array.isArray(loadFileParams.fileList)) {
        loadFileParams.fileList = [loadFileParams.fileList]
      }
      this.init(loadFileParams.fileList, loadFileParams.httpOptions)
    }
  }
  /**
   * @description: 下载进度变化
   * @return {*}
   * @internal
   */
  downloadProgressChange() {
    const that = this
    this.downloadProgressChangeFun = (file, bytesReceived, bytesTotal) => {
      const currentFile = downloadList.find((el) => {
        return el.tempPath === file
      })
      let loadPercentage = 0
      if (bytesTotal) {
        loadPercentage = (bytesReceived / bytesTotal) * 100
      }
      downloadMap[file] = loadPercentage
      // 更新消息
      that.changeStatus('downloading', '下载中...', currentFile, loadPercentage)
    }
    return this.downloadProgressChangeFun
  }
  /**
   * @description: 下载模型成功回调
   * @return {*}
   * @internal
   */
  downloadFinishMsg() {
    const that = this
    this.downloadFinishFun = async (file, err, bytesTotal) => {
      const currentFileIndex = downloadList.findIndex((el) => {
        return el.tempPath === file
      })
      if (currentFileIndex !== -1) {
        const currentFile = downloadList.splice(currentFileIndex, 1)
        downloadMap[file] = err ? -1 : 100

        // 存在则报错
        if (err) {
          // 更新消息
          that.changeStatus('downloadError', err, currentFile[0] ?? undefined)
          return
        }
        // 检查下载的md5是否一致
        // const downloadFileMd5 = await that.player.Native?.File.getFileMd5(file)
        // if (downloadFileMd5 === currentFile[0]?.md5.toLocaleLowerCase()) {
        const moveStatus = await that.player.Native?.File.move(
          currentFile[0]?.tempPath,
          currentFile[0]?.targetUrl
        )
        if (moveStatus) {
          const fileType = _.last(currentFile[0]?.targetUrl.split('.'))
          if (fileType === 'zip') {
            await that.player.Native.UiQt.decompressingZIP(currentFile[0]?.targetUrl, '')
          }
        }
        // 更新消息
        that.changeStatus(
          moveStatus ? 'downloadSuccess' : 'moveError',
          moveStatus ? '下载成功' : '模型移动失败',
          currentFile[0] ?? undefined
        )
        // } else {
        //   that.changeStatus(
        //     'downloadError',
        //     '下载的文件与模型的md5不一致',
        //     currentFile[0] ?? undefined
        //   )
        // }
      }
    }
    return this.downloadFinishFun
  }
  setConnect() {
    // 设置下载的监听
    this.player.Native?.File.EventDownloadProcessChanged.connect(this.downloadProgressChange())
    this.player.Native?.File.EventDownloadFinish.connect(this.downloadFinishMsg())
  }
  disconnect() {
    // 设置下载的监听
    this.player.Native?.File.EventDownloadProcessChanged.disconnect(this.downloadProgressChange())
    this.player.Native?.File.EventDownloadFinish.disconnect(this.downloadFinishMsg())
  }
  async init(fileList, httpOptions) {
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i]
      downloadMap[file.tempPath] = 0
      const isExistFile = await this.checkFile(file.targetUrl)
      if (isExistFile) {
        downloadMap[file.tempPath] = 100
        this.changeStatus('downloadSuccess', '模型下载完成！', {
          tempPath: file.tempPath || '',
          targetUrl: file.targetUrl,
          md5: file.md5 || '',
        })
        return
      }
      // 创建下载任务
      const res = await this.player.Native?.File.downloadFile(
        file.tempPath,
        httpOptions?.methods || 'GET',
        file.fileUrl,
        httpOptions?.header || {}
      )
      if (res) {
        // 存储当前处于下载的队列,tempPath一定存在
        downloadList.push({
          tempPath: file.tempPath || '',
          targetUrl: file.targetUrl,
          md5: file.md5 || '',
        })
      } else {
        this.changeStatus('downloadError', '创建下载模型任务失败！', {
          tempPath: file.tempPath || '',
          targetUrl: file.targetUrl,
          md5: file.md5 || '',
        })
      }
    }
  }
  async checkFile(targetUrl) {
    // 检查文件是否存在
    const isExistFile = await this.player.Native?.File.exists(targetUrl)
    return isExistFile
  }
  changeStatus(status, message, currentFile, process = -1) {
    window.dispatchEvent(
      new CustomEvent('FileChange', {
        detail: {
          message,
          downloadMap,
          data: {
            currentState: status,
            process,
            ...currentFile,
          },
        },
      })
    )
  }
}
